import { Form as BForm, type FormProps } from "@coideo/barrani";
import { useTranslation } from "next-i18next";
import { type FieldValues } from "react-hook-form";

import Button, { type ButtonProps } from "./Button";

const FormComponent = <T extends FieldValues>(props: FormProps<T>) => <BForm {...props} />;

function SubmitButton({ children, ...props }: ButtonProps) {
  const { t } = useTranslation();

  return (
    <BForm.SubmitButton {...props}>
      {(rest: ButtonProps) => <Button {...rest}>{children ?? t("generic.save")}</Button>}
    </BForm.SubmitButton>
  );
}

function CancelButton({ children, ...props }: ButtonProps) {
  const { t } = useTranslation();

  return (
    <BForm.CancelButton {...props}>
      {(rest: ButtonProps) => (
        <Button kind="light" {...rest}>
          {children ?? t("generic.cancel")}
        </Button>
      )}
    </BForm.CancelButton>
  );
}

const Form = Object.assign(FormComponent, BForm, {
  SubmitButton,
  CancelButton,
});

export default Form;
